export const testUsername = (uname) => {
  let notAllowed = '!#$%^&@*()+{}:"<>?-=[];\'/'
  if (uname.split('').some((c) => notAllowed.includes(c))) {
    return false
  }
  return true
}
